export default class BuilderQueue<T> {
    private queue: T[];

    constructor(queue?: T[]) {
        this.queue = queue || [];
    }

    setQueue(queue: T[]) {
        this.queue = queue;
    }

    enqueue(item: T | T[]) {
        if (Array.isArray(item)) {
            item.forEach(individualItem => this.queue.push(individualItem));
        }
        else {
            this.queue.push(item);
        }
    }

    dequeue(): T | undefined {
        return this.queue.shift();
    }

    enqueueFirst(t: T) {
        this.queue.unshift(t);
    }

    isEmpty(): boolean {
        return this.queue.length === 0;
    }

    size(): number {
        return this.queue.length;
    }

    elements(): T[] {
        return this.queue;
    }

    clear() {
        this.queue = [];
    }

}